module.exports = __webpack_public_path__ + "img/arrow-right.d0f6a174.svg";